module.exports = __webpack_public_path__ + "media/src/pages/PreApplication/images/success-3-e88f2b0f89ca6493f9576a1a9047f1f8.png";